import { SiMonkeytie } from "react-icons/si";

const EmailStep = ({
  email,
  setEmail,
  isLoading,
  onSubmit,
  onCancel,
}: EmailStepProps) => (
  <form onSubmit={onSubmit} className="w-full space-y-4">
    <div className="bh-gray-7 rounded-[10px] p-4 bg-black justify-self-center">
      <SiMonkeytie className="text-2xl text-center text-white" />
    </div>
    <div className="space-y-2">
      <h1 className="text-2xl font-bold text-center text-gray-7">
        Forgot Password?
      </h1>
      <p className="text-gray-5 text-center">
        Enter your email address and we'll send you a reset token.
      </p>
    </div>
    <div className="space-y-2">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Enter your email"
        required
        className="w-full mb-8 px-4 py-2 border border-gray-3 rounded-lg focus:ring-1 focus:ring-gray-5 focus:border-gray-5 outline-none"
      />
    </div>
    <button
      type="submit"
      disabled={isLoading}
      className="w-full px-4 py-2 text-white bg-black rounded-lg hover:bg-gray-6 focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isLoading ? "Sending..." : "Send Reset Token"}
    </button>
    <button
      type="button"
      onClick={onCancel}
      className="w-full px-4 py-2 text-black rounded-lg border border-gray-7 hover:bg-gray-2 hover:text-white focus:outline-none focus:ring-1 focus:ring-gray-5 focus:ring-offset-2"
    >
      Cancel
    </button>
  </form>
);

export default EmailStep;

interface EmailStepProps {
  email: string;
  setEmail: (email: string) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  onCancel: () => void;
}
